// Core React
import React from 'react';
import { connect } from 'react-redux';

// Redux slice
import { setActiveBlock, setHologramPosition, addToSwap, clickAway } from 'components/collage/CollageSlice.js';

// 3rd party components
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

// Custom Components
import BlockBorder from './BlockBorder.js';

// CSS
import './Block.css';

class Block extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      positionX: this.props.photo.initial_position.x,
      positionY: this.props.photo.initial_position.y,
      scale: this.props.photo.scale,
      mouseOver: false
    }

    this._clickBuffer = 150;
    this._allowClick  = false;
    this._hideHoloId  = false;
    this._panTimer    = 0;
  }

  componentDidMount() {
    this.gandrWorker = new Worker('js/gw.js');
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.photo.gandr_size.width != this.props.photo.gandr_size.width
      || nextProps.photo.gandr_size.height != this.props.photo.gandr_size.height
      || nextProps.photo.gandr_pos.x != this.props.photo.gandr_pos.x
      || nextProps.photo.gandr_pos.y != this.props.photo.gandr_pos.y
      || nextProps.photo.scale != this.props.photo.scale
      || nextProps.photo.initial_position.x != this.props.photo.initial_position.x
      || nextProps.photo.initial_position.y != this.props.photo.initial_position.y
      || nextProps.exportStep != this.props.exportStep
      || nextProps.collage.activeBlock != this.props.collage.activeBlock
      || (nextProps.collage.swap.length == 1 && nextProps.collage.swap[0] == this.props.photo.src)

      || nextState.positionX != this.state.positionX
      || nextState.positionY != this.state.positionY
      || nextState.scale != this.state.scale
      || nextState.mouseOver != this.state.mouseOver
    )
  }

  componentDidUpdate(prevProps, prevState) {

    // If position/size changed, then reset pan position
    if ( prevProps.photo.gandr_size.width != this.props.photo.gandr_size.width
      || prevProps.photo.gandr_size.height != this.props.photo.gandr_size.height
    ) {
      this.setState({
        positionX: this.props.photo.initial_position.x,
        positionY: this.props.photo.initial_position.y,
        // scale: !this._zoomed ? this.props.photo.scale : this.state.scale,
        scale: this.props.photo.scale
      });
    }
    
  }

  // Mouseover event because we can't do it with css (can't combine inline style transforms with stylesheet hovers)
  handleMouseOver = () => {
    this.setState({
      mouseOver: true
    })
  }

  // Mouseover event because we can't do it with css (can't combine inline style transforms with stylesheet hovers)
  handleMouseOut = () => {
    this.setState({
      mouseOver: false
    })
  }

  handlePanStart = () => {
    // console.log('pan start');
    this._panTimer = performance.now();
    this._hideHoloId = setTimeout(() => {

      this._allowClick = false;

      if ( this.props.collage.activeBlock != this.props.photo.src ) {
        this.props.setActiveBlock(null);
      }

      this.props.clickAway({resetHologram: true});

    }, this._clickBuffer);
  }

  handlePanEnd = (event) => {
    let timeSinceStart = (performance.now() - this._panTimer);

    if ( timeSinceStart < this._clickBuffer ) {
      this._allowClick = true;
      clearTimeout(this._hideHoloId);
    }
    
    this.state.positionX = event.positionX;
    this.state.positionY = event.positionY;
  }

  handleZoomChange = (event) => {
    this.state.scale = event.scale;
    this.state.positionX = event.positionX;
    this.state.positionY = event.positionY;
  }

  handlePan = (event) => {
    this.state.positionX = event.positionX;
    this.state.positionY = event.positionY;
  }

  render() {

    let className         = ['Block'];
    let thisBlockActive   = this.props.collage.activeBlock && this.props.collage.activeBlock == this.props.photo.src;
    let isSwapping        = this.props.collage.swap.length === 1;
    let thisSwapActive    =  isSwapping&& this.props.collage.swap[0] == this.props.photo.src;

    if ( thisBlockActive ) {
      className.push('Block--Highlight');
    }

    // If this is the original photo chosen to be swapped, scale it up a little bit
    // if ( this.props.collage.swap.length == 1 && this.props.collage.swap[0] == this.props.photo.src ) {
    //   className.push('Block--SwapActive');
    // }

    // If this is the original photo chosen to be swapped, scale it up a little bit
    if ( this.state.mouseOver ) {
      className.push('Block--Hover');
    }


    let blockPositioning;
    if ( this.props.exportStep > 1 ) {
      blockPositioning = {
        left: this.props.photo.gandr_pos.x,
        top: this.props.photo.gandr_pos.y,
      }
    }
    else {
      blockPositioning = {
        transform: 'translate3d('+this.props.photo.gandr_pos.x+'px,'+this.props.photo.gandr_pos.y+'px,0)' + ((thisSwapActive || (isSwapping && this.state.mouseOver)) ? ' scale(1.1)' : '')
      }
    }
    const style = {
      width: Math.ceil(this.props.photo.gandr_size.width),
      height: Math.ceil(this.props.photo.gandr_size.height),
      padding: this.props.collage.borderWidth > 0 ? 2 : 0,
      // backgroundColor: '#' + Math.floor(Math.random()*16777215).toString(16)
      ...blockPositioning
    }

    const imgStyle = {
      width: Math.ceil(this.props.photo.width),
      height: Math.ceil(this.props.photo.height)
    }
    
    return (
      <div 
        className={className.join(' ')} 
        style={style}
        onMouseEnter={this.handleMouseOver}
        onMouseLeave={this.handleMouseOut}
      >
        <TransformWrapper
            scalePadding={{disabled: true}}
            pan={{
              // velocity: true,
              // velocityEqualToMove: true,
              // padding: false,
              velocitySensitivity: 0,
              paddingSize: 0,
              animationTime: 0,
            }}
            defaultScale={this.props.photo.scale}
            scale={this.state.scale}
            defaultPositionX={this.props.photo.initial_position.x}
            defaultPositionY={this.props.photo.initial_position.y}
            positionX={this.state.positionX}
            positionY={this.state.positionY}
            enablePadding={false}
            enablePanPadding={false}
            onPanningStart={this.handlePanStart}
            onPanningStop={this.handlePanEnd}
            onPanning={this.handlePan}
            onPinching={this.handleZoomChange}
            onWheelStart={this.handleZoomChange}
            onZoomChange={this.handleZoomChange}
            wheel={{
              step: 3
            }}
            doubleClick={{
              disabled: true
            }}
            options={{
              minScale: 1,
              centerContent: false,
              // limitToBounds: false
              // limitToWrapper: true
            }}
          >
            {({ zoomIn, zoomOut, resetTransform, setTransform, ...rest }) => (
              <React.Fragment>
              {/* <button onClick={resetTransform} className={'actiontest'}>x</button> */}
                <TransformComponent>
                  <button 
                    className="BlockButton ButtonReset"
                    onClick={(event) => {

                      if ( this._allowClick ) {

                        if ( this.props.collage.swap.length == 1 ) {
                          this.props.addToSwap(this.props.photo.src);
                        }
                        else {
                          this.props.setActiveBlock(this.props.photo.src);
                          this.props.setHologramPosition({
                            x: event.nativeEvent.pageX,
                            y: event.nativeEvent.pageY
                          })
                        }

                      }
                      else {
                        console.log('no allow click');
                      }
                      
                    }}
                  >
                    <img 
                      className="BlockImage"
                      src={this.props.photo.src} 
                      style={imgStyle}
                    />
                  </button>
                </TransformComponent>
              </React.Fragment>
            )}
          </TransformWrapper>
          <span className="sr-only">Select Photo</span>
       
          <BlockBorder 
            photo={this.props.photo}
          />
       
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setActiveBlock, setHologramPosition, clickAway, addToSwap}
)(Block)
